/*
 * Copyright (c) 2020. Jellybean B.V. Apeldoorn
 * Jellybean B.V. Apeldoorn heeft een licentie verleend aan
 * Spin in het Web B.V. Apeldoorn voor het gebruik van deze software-
 * onderdelen in projecten voor derden. U heeft géén toestemming
 * tot inzage of wijziging in de (bron)code van deze onderdelen.
 */

/*
* sihwsemaphore.module.ts
* 23-3-2020 - Jelmer Jellema - Spin in het Web B.V.
*/
import {NgModule} from '@angular/core';
import {LocalconfigModule} from '../localconfig/localconfig.module';
import {SihwlogModule} from '../sihwlog/sihwlog.module';
import {Sihwsemaphore} from './sihwsemaphore';

@NgModule({
  declarations: [],
  imports: [
    LocalconfigModule,
    SihwlogModule
  ],
  providers: [
    Sihwsemaphore
  ]
}) export class SihwsemaphoreModule {}
